import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useEffect } from "react";
import { useMediaQuery } from "@/hooks/useMediaQuery";

export function ImpersonationBanner({
  sidebarOpen,
  sidebarCollapsed,
}: {
  sidebarOpen: boolean;
  sidebarCollapsed: boolean;
}) {
  const { user, originalUser, stopImpersonating, isImpersonating } = useAuth();
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {}, [user, originalUser, isImpersonating]);

  if (!user || !originalUser || !isImpersonating) {
    return null;
  }

  // Calculate left margin based on sidebar state
  const getLeftMargin = () => {
    if (isMobile || !sidebarOpen) return "ml-0";
    return sidebarCollapsed ? "md:ml-14" : "md:ml-56";
  };

  return (
    <div
      className={`fixed top-14 left-0 right-0 z-[40] border-b-2 shadow-md ${getLeftMargin()}`}
      style={{ 
        backgroundColor: 'var(--primary)', 
        borderColor: 'var(--primary)', 
        opacity: 0.9 
      }}
    >
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="py-2 flex items-center justify-between">
          <div className="flex items-center">
            <p className="text-sm text-white font-semibold">
              You are currently impersonating{" "}
              <span className="font-semibold">
                {user.user_metadata?.first_name} {user.user_metadata?.last_name}{" "}
                ({user.email})
              </span>
            </p>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={stopImpersonating}
            className="text-white hover:bg-white/20 border border-white/50 bg-white/10 backdrop-blur-sm"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Stop Impersonating
          </Button>
        </div>
      </div>
    </div>
  );
}
